export const TRANSLATION_KEY = 'billing';

export const MODULE_KEY = 'billing';

export const PATHS = {
  BILLING: '/billing',
  PAYMENT_SUCCESS: '/billing/payment-success',
  PAYMENT_PENDING: '/billing/payment-pending',
  PAYMENT_FAILED: '/billing/payment-failed',
};

export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'ACTIVE',
  CANCELED: 'CANCELED',
  ENDED: 'ENDED',
  PAST_DUE: 'PAST_DUE',
  TRIALING: 'TRIALING',
  UNPAID: 'UNPAID',
  PAUSED: 'PAUSED',
  INCOMPLETE: 'INCOMPLETE',
  INCOMPLETE_EXPIRED: 'INCOMPLETE_EXPIRED',
};

export const NEEDS_PAYMENT_STATUSES = new Set([
  SUBSCRIPTION_STATUS.PAST_DUE,
  SUBSCRIPTION_STATUS.UNPAID,
  SUBSCRIPTION_STATUS.INCOMPLETE,
]);

export const DEFAULT_FEATURES = [
  { labelKey: 'FEATURE_FULL_ACCESS', checked: true },
  { labelKey: 'FEATURE_USAGE_BASED', checked: true },
  { labelKey: 'FEATURE_VOLUME_DISCOUNTS', checked: true },
  { labelKey: 'FEATURE_LOWER_COSTS', checked: true },
  // { labelKey: 'FEATURE_CUSTOM_LIMITS', checked: false, tag: 'Scale' },
];

export const BILLING_PERIOD = {
  MONTHLY: 'month',
  ANNUALLY: 'year',
};

export const INVOICE_STATUS = {
  DRAFT: 'DRAFT',
  OPEN: 'OPEN',
  PAID: 'PAID',
  EXPIRED: 'EXPIRED',
  VOID: 'VOID',
  CANCELED: 'CANCELED',
};
export const INVOICE_TYPE_TEXT = {
  SUBSCRIPTION: 'Subscription',
  DEPOSIT: 'Deposit',
  SUBSCRIPTION_RENEWAL: 'Subscription renewal',
};

export const TX_TYPE = {
  INVOICE: 'INVOICE',
  REPLENISH: 'REPLENISH',
};

export const INVOICE_TYPE_TO_TX_TYPE = {
  SUBSCRIPTION: TX_TYPE.INVOICE,
  SUBSCRIPTION_RENEWAL: TX_TYPE.INVOICE,
  DEPOSIT: TX_TYPE.REPLENISH,
};

export const VISIBLE_INVOICE_STATUSES = new Set([
  INVOICE_STATUS.OPEN,
  INVOICE_STATUS.PAID,
  INVOICE_STATUS.EXPIRED,
]);

export const MINIMUM_BALANCE = 20;
export const MINIMUM_DEPOSIT = 1;
export const MAXIMUM_DEPOSIT = 5000;

export const CARD_STYLE = {
  TRIAL: 'trial',
  ERROR: 'error',
  WARNING: 'warning',
  INACTIVE: 'inactive',
  DEFAULT: 'default',
};
